/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// Get list
export function authRoleList(query) {
    return axios({
        url: "/admin/auth/role/index",
        method: "get",
        params: query
    });
}

// edit
export function authRoleAuthList(query) {
    return axios({
        url: "/admin/auth/role/authList",
        method: "get",
        params: query
    });
}

// add
export function authRoleAuth(data) {
    return axios({
        url: "/admin/auth/role/auth",
        method: "post",
        data: data
    });
}

// save
export function authRoleSave(data, formName, method = "post") {
    let url =
        formName === "Add" ? "/admin/auth/role/save" : "/admin/auth/role/edit";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// delete
export function authRoleDelete(data) {
    return axios({
        url: "/admin/auth/role/delete",
        method: "post",
        data: data
    });
}